import React from "react";
import { Collapse, List, Typography, Row, Col, Divider, Empty } from "antd";
import formatDate from "utilities/formats/formatDate";
import dayjs from "dayjs";

const { Panel } = Collapse;
const { Text, Link } = Typography;

const RequestsList = ({ requests }) => {
  const formatName = (performedBy) =>
    ` by ${performedBy.firstName} ${performedBy.lastName} (${performedBy.initials})`;

  const renderDocument = (document) => (
    <>
      <Row gutter={[8, 4]}>
        {document.type && (
          <Col span={10}>
            {" "}
            <Text>{document.type}</Text>
          </Col>
        )}
        {document.number && (
          <Col span={8}>
            <Text>Number: {document.number}</Text>
          </Col>
        )}
        <Col>
          {document.name && <Link href={document.sasUrl}>{document.name}</Link>}
        </Col>
      </Row>
      <Row gutter={[8, 4]}>
        <Col span={4}>
          {document.date ? (
            <Text>{dayjs(document.date).format("DD/MM/YYYY")}</Text>
          ) : (
            <Text type="secondary">No date</Text>
          )}
        </Col>
      </Row>
      <Divider
        style={{
          margin: "4px 0",
        }}
      />
    </>
  );

  const renderAction = (action) => (
    <div style={{ padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
      <Row justify="space-between">
        <Col>
          <Text>{`${action.actionType}${
            action.performedBy ? formatName(action.performedBy) : ""
          }`}</Text>
        </Col>
        <Col>
          <Text>{formatDate(action.actionDate)}</Text>
        </Col>
      </Row>
      {action.comments && (
        <>
          <Divider type="vertical" />
          <Text>Comments: {action.comments}</Text>
        </>
      )}
    </div>
  );
  if (!requests || requests.length === 0) {
    return (
      <Empty>
        <Text type="secondary">No history found</Text>
      </Empty>
    );
  }
  return (
    <Collapse accordion expandIconPosition="end">
      {requests.map((request, index) => (
        <Panel
          header={`${dayjs(request.requestDate).format("DD/MM/YYYY")} - ${
            request.requestType
          }`}
          key={index}
          extra={<Text type="secondary">{request.currentStatus}</Text>}
        >
          {request.actions && request.actions.length > 0 && (
            <List dataSource={request.actions} renderItem={renderAction} />
          )}
          {request.documentation && request.documentation.length > 0 && (
            <>
              <List
                header={<Text strong>Documentation:</Text>}
                dataSource={request.documentation}
                renderItem={renderDocument}
                split
              />
            </>
          )}
        </Panel>
      ))}
    </Collapse>
  );
};

export default RequestsList;
